import { map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { deserialize } from 'santee-dcts';
import { Observable, of } from 'rxjs';

import { Settings } from '../../core';
import { Project, ProjectReadModel } from './project';
import { SitesReadModel } from '../../sites/sites-read.model';

@Injectable()
export class ProjectsStorage {
    constructor(
        private readonly http: HttpClient,
        private readonly settings: Settings
    ) { }

    public search(searchTerm: string): Observable<Project[]> {
        return searchTerm
            ? this.http.get(`${this.settings.apiUrl}/projects/search`, { params: { searchTerm } })
                .pipe(map(projects => deserialize(projects, ProjectReadModel).projects))
            : of([]);
    }

    public getProjectSites(subProtocolId: number) {
        return this.http.get(`${this.settings.apiUrl}/projects/${subProtocolId}/sites`)
            .pipe(map(sites => deserialize(sites, SitesReadModel).sites));
    }

}